import { PUT_HOW_TO_APPLY_ERROR, PUT_HOW_TO_APPLY_START, PUT_HOW_TO_APPLY_SUCCESS } from '../../types';

export default function put_how_to_apply(state, action) {
  switch (action.type) {
    case PUT_HOW_TO_APPLY_START:
      return { ...state };
    case PUT_HOW_TO_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_HOW_TO_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}